import script from "./avatar.vue?vue&type=script&setup=true&lang=js"
export * from "./avatar.vue?vue&type=script&setup=true&lang=js"

import "./avatar.vue?vue&type=style&index=0&id=16a5aeb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a5aeb2"]])

export default __exports__